import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class AnnouncementOpenReleaseUpdatesClicked extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ANNOUNCEMENT_OPEN_RELEASE_UPDATES_CLICKED;

  announcementId: number;

  constructor(announcementId: number) {
    super();

    this.announcementId = announcementId;
  }
}
